module.exports = __webpack_public_path__ + "static/media/find_food.9801b222.svg";